import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, GLOBAL_LAYOUT_KEY } from './common';

const routes = [
    {
        matchRegex: GLOBAL_LAYOUT_KEY,
        name: 'Global layout',
        slots: [SLOT_KEY.SLOT_SCRIPTS],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_UPDATE_LEFT_SIDEBAR',
                    label: 'Trigger Updated Left Sidebar',
                },
                {
                    key: 'MARKETPLACE_EVENT_SIGNALR_TRIGGER',
                    label: 'Trigger Signal R Event',
                },
                {
                    key: 'MARKETPLACE_EVENT_INTERNAL_TRIGGER',
                    label: 'Trigger Internal event',
                },
            ],
        },
    },
]

export default routes;